var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinAltLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin_alt_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 40",
    d: "M23.3949 20.5417C24.2963 21.0927 24.7709 21.7178 24.7709 22.3542C24.7709 22.9905 24.2963 23.6156 23.3949 24.1667C22.4934 24.7177 21.1969 25.1753 19.6355 25.4935C18.0741 25.8117 16.303 25.9792 14.5001 25.9792C12.6972 25.9792 10.926 25.8117 9.36467 25.4935C7.8033 25.1753 6.50673 24.7177 5.60528 24.1667C4.70383 23.6156 4.22925 22.9905 4.22925 22.3542C4.22925 21.7178 4.70382 21.0927 5.60528 20.5417",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 41",
    d: "M23.5625 12.0833C23.5625 18.2423 16.7202 22.3649 14.9264 23.34C14.6575 23.4861 14.3425 23.4861 14.0736 23.34C12.2798 22.3649 5.4375 18.2423 5.4375 12.0833C5.4375 6.64584 9.82859 3.02084 14.5 3.02084C19.3333 3.02084 23.5625 6.64584 23.5625 12.0833Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 5",
    d: "M18.8334 12.0833C18.8334 14.4766 16.8933 16.4167 14.5001 16.4167C12.1068 16.4167 10.1667 14.4766 10.1667 12.0833C10.1667 9.6901 12.1068 7.75 14.5001 7.75C16.8933 7.75 18.8334 9.6901 18.8334 12.0833Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAltLight);
export default __webpack_public_path__ + "static/media/Pin_alt_light.42488c17ecaa527266c8d2b9b37ab519.svg";
export { ForwardRef as ReactComponent };